import { useState, useContext, useEffect, useRef } from "react";
import { Menu, MenuItem } from "react-pro-sidebar";
import { Box, Divider, IconButton, Typography } from "@mui/material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import "./Navbar.scss";
import { AppContext } from "context/AppContext";
import Grid from "@mui/material/Grid2";
import { MenuDataNav } from "./MenuDataNav.ts";
import { MenuData } from "./MenuData.ts";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import AssessmentOutlinedIcon from '@mui/icons-material/AssessmentOutlined';
import TrafficRoundedIcon from "@mui/icons-material/TrafficRounded";
import ApartmentRoundedIcon from "@mui/icons-material/ApartmentRounded";
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import LocalLibraryIcon from '@mui/icons-material/LocalLibrary';
import { CANT_CLAIM_HV_IVE, CANT_MESA_DE_ENTRADA, CANT_TICKETS } from "constant/endpoints";


const ItemNav = ({
  index,
  title,
  to,
  isActive,
  subItems,
  isOpen,
  setOpenSubMenu,
}) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Lo usamos para que se lea el comportamiento del mouse fuera del item
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && menuRef.current && !menuRef.current.contains(event.target)) {
        setOpenSubMenu(null);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen, setOpenSubMenu]);
  //---------------------------------------------------------------------
  const handleToggle = (e) => {
    e.stopPropagation();
    setOpenSubMenu((prev) => (prev === index ? null : index));
  };

  const handleNavigation = (path) => {
    navigate(path);
    setOpenSubMenu(null);
  };
  const handleIcon = (icon) => {
    const icons = {
      "/administrar": <AdminPanelSettingsIcon sx={{ marginRight: "10px" }} />,
      "administrar/archivados": (
        <FolderOutlinedIcon sx={{ marginRight: "10px" }} />
      ),
      "administrar/reportes": (
        <AssessmentOutlinedIcon sx={{ marginRight: "10px" }} />
      ),
      "administrar/estandares-y-protocolos": (
        <LocalLibraryIcon sx={{ marginRight: "10px" }} />
      ),
      "/configuracion": <SettingsOutlinedIcon sx={{ marginRight: "10px" }} />,
      "configuracion/sistema-de-semaforos": (
        <TrafficRoundedIcon sx={{ marginRight: "10px" }} />
      ),
      "configuracion/datos-organismos": (
        <ApartmentRoundedIcon sx={{ marginRight: "10px" }} />
      ),
    };
    return icons[icon];
  };

  return (
    <>
      <Box ref={menuRef} sx={{ display: "flex", alignItems: "center" }}>
        <MenuItem
          active={isActive}
          className="swt-navbar-links"
          component={
            !subItems && (
              <Link
                to={to}
                sx={{ cursor: "pointer" }}
                onClick={() => navigate(to)}
              />
            )
          }
          rel="noopener noreferrer"
        >
          <div className="swt-navbar-links-content">
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {handleIcon(to)}
              <Typography
                className="swt-navbar-links-title"
                color={isActive ? "#fff" : ""}
              >
                {title}
              </Typography>
            </Box>
            {subItems && (
              <IconButton onClick={handleToggle}>
                {isOpen ? (
                  <KeyboardArrowUpIcon sx={{ color: "#fff" }} />
                ) : (
                  <KeyboardArrowDownIcon sx={{ color: "#fff" }} />
                )}
              </IconButton>
            )}
          </div>
          {isOpen && subItems && (
            <Box
              sx={{
                background: "#00AEC3",
                width: "100%",
                position: "absolute",
                zIndex: "100",
                borderRadius: "10px",
                left: "0",
                marginTop: "6px",
              }}
            >
              {subItems.map((subItem, index) => (
                <MenuItem
                  key={index}
                  active={location.pathname === `/${subItem.path}`}
                  sx={{ fontSize: "10px" }}
                  className="swt-navbar-sub-links"
                  onClick={() => handleNavigation(subItem.path)}
                >
                  <Box sx={{ display: "flex", alignItems: "center" }}>
                    {handleIcon(subItem.path)}
                    <Typography className="swt-navbar-sub-links-title">
                      {subItem.title}
                    </Typography>
                  </Box>
                </MenuItem>
              ))}
            </Box>
          )}
        </MenuItem>
      </Box>
    </>
  );
};
const Item = ({ title, to, isActive, subItems, cantClaim, cantMesaEntrada }) => {
  const navigate = useNavigate();
  const [isOpen, setIsOpen] = useState(false);

  const handleTo = () => {
    navigate(to);
  };
  let location = useLocation();

  // Ver si el item actual pertenece a ME o R. HV
  const isHv = title === "Reclamos IVE";
  const isMesaEntrada = title === "Mesa de entrada";
  // Mostramos el número según el título
  const currentCount = isHv ? cantClaim : (isMesaEntrada ? cantMesaEntrada : 0);
  const showBadge = currentCount > 0;

  return (
    <>
      {!subItems ? (
        <MenuItem
          active={isActive}
          className={`swt-topbar-links ${title === "Reclamos IVE" ? "nav-hv" : ""
            }`}
          onClick={() => handleTo()}
          component={<Link to={to} sx={{ height: "30px !important" }} />}
          rel="noopener noreferrer"
        >
          {showBadge && (
            <Box
              sx={{
                position: "absolute",
                top: "-10px",
                right: "15px",
                // Si es HV usa morado, si es Mesa de entrada usa un color distintivo (ej. turquesa)
                background: isHv ? "#B31EA4" : "#00AEC3",
                minWidth: "24px",
                height: "24px",
                padding: "0 6px",
                borderRadius: "12px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                marginBottom: { xs: "20px", md: "0px" },
                textAlign: "center",
                animation: "pulse 1.5s ease-in-out infinite",
                "@keyframes pulse": {
                  "0%": {
                    opacity: 1,
                    transform: "scale(1)",
                    boxShadow: "0 0 0 0 rgba(179, 30, 164,0.4)",
                  },
                  "70%": {
                    opacity: 1,
                    transform: "scale(1.05)",
                    boxShadow: "0 0 0 10px rgba(179, 30, 164, 0)",
                  },
                  "100%": {
                    opacity: 1,
                    transform: "scale(1.1)",
                    boxShadow: "0 0 0 0 rgba(179, 30, 164, 0)",
                  },
                },
              }}
            >
              <Typography sx={{ fontSize: "12px", color: "#fff", fontWeight: "600" }}>{currentCount} Sin asignar</Typography>
            </Box>
          )}
          <div className="swt-topbar-links-content">
            <Box
              sx={{ display: "flex", alignItems: "center" }}
              onClick={() => setIsOpen(!isOpen)}
            >
              <Typography
                className="swt-topbar-links-title"
                color={isActive ? "#fff" : ""}
              >
                {title}
              </Typography>
            </Box>
          </div>
        </MenuItem>
      ) : (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            width: "100%",
            contain: "layout",
          }}
        >
          <MenuItem
            active={isActive}
            className="swt-topbar-links"
            onClick={() => {
              setIsOpen(!isOpen);
            }}
            rel="noopener noreferrer"
          >
            <div className="swt-topbar-links-content">
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  className="swt-topbar-links-title"
                  color={isActive ? "#fff" : ""}
                >
                  {title}
                </Typography>
              </Box>
            </div>
          </MenuItem>
          {isOpen && subItems && (
            <Box
              sx={{
                position: "fixed",
                width: "100%",
                marginTop: "101px",
                borderRadius: "10px",
                backgroundColor: "#00AEC3",
              }}
            >
              {subItems.map((subItem, index) => {
                const isEditUserRoute = subItem.path.startsWith(
                  "gestion-de-usuarios/editar-usuario"
                );
                if (!subItem.show) return null;
                return (
                  <MenuItem
                    key={index}
                    active={subItem.path === location.pathname.substring(1)}
                    className="swt-topbar-links-sub-item"
                    onClick={() => {
                      if (!isEditUserRoute) {
                        navigate(subItem.path);
                        setIsOpen(!isOpen);
                      }
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      <Typography
                        sx={{ fontFamily: "Encode Sans" }}
                        className="swt-topbar-links-sub-item-title"
                      >
                        {subItem.title}
                      </Typography>
                    </Box>
                  </MenuItem>
                );
              })}
            </Box>
          )}
        </Box>
      )}
    </>
  );
};
const getHeaders = (menu, navMenu, path) => {
  const matchRoute = (itemPath, currentPath) => {
    const regex = new RegExp(`^${itemPath.replace(/:\w+/g, "[a-zA-Z0-9-]+")}$`);
    return regex.test(currentPath);
  };

  for (let item of menu) {
    if (matchRoute(item.path, path)) {
      return {
        headerTitle: item.headerTitle || "Título no encontrado",
        headerSubTitle: item.headerSubTitle || "Subtítulo no encontrado",
      };
    }

    if (item.subItems) {
      const foundSubItem = item.subItems.find((subItem) =>
        matchRoute(subItem.path, path)
      );
      if (foundSubItem) {
        return {
          headerTitle: foundSubItem.headerTitle || "Título no encontrado",
          headerSubTitle:
            foundSubItem.headerSubTitle || "Subtítulo no encontrado",
        };
      }
    }
  }

  for (let item of navMenu) {
    if (matchRoute(item.path, path)) {
      return {
        headerTitle: item.headerTitle || "Título no encontrado",
        headerSubTitle: item.headerSubTitle || "Subtítulo no encontrado",
      };
    }

    if (item.subItems) {
      const foundSubItem = item.subItems.find((subItem) =>
        matchRoute(subItem.path, path)
      );
      if (foundSubItem) {
        return {
          headerTitle: foundSubItem.headerTitle || "Título no encontrado",
          headerSubTitle:
            foundSubItem.headerSubTitle || "Subtítulo no encontrado",
        };
      }
    }
  }
  return {
    headerTitle: "Título no encontrado",
    headerSubTitle: "Subtítulo no encontrado",
  };
};

// Función para filtrar menús y submenús según Rol y Subrol
const filterMenuByRoles = (menuArray, userRole, userSubRole) => {
  return menuArray
    .filter((item) => {
      // verifico Rol principal
      if (item.rolesAllowed && !item.rolesAllowed.includes(userRole)) {
        return false;
      }
      // verifico Subrol solo si este item en el MenuData exige uno
      if (item.subRolesAllowed && item.subRolesAllowed.length > 0) {
        if (!userSubRole || !item.subRolesAllowed.includes(userSubRole)) {
          return false;
        }
      }
      return true;
    })
    .map((item) => {
      // Si el menú tiene subItems, hacemos lo mismo
      if (item.subItems) {
        return {
          ...item,
          subItems: filterMenuByRoles(item.subItems, userRole, userSubRole),
        };
      }
      return item;
    });
};
function Navbar(props) {
  const { api, navMenuData, setNavMenuData } = props;
  const [menu, setMenu] = useState([]);
  const [cantClaim, setCantClaim] = useState(0);
  // estado para guardar el número de Mesa de Entrada
  const [cantMesaEntrada, setCantMesaEntrada] = useState(0);
  const { isNavbarCollapsed, setIsNavbarCollapsed } = props;
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const { account } = useContext(AppContext);
  const [currentPath, setCurrentPath] = useState("");

  const [cantClaimAssigned, setCantClaimAssigned] = useState(0);
  const [cantMesaEntradaAssigned, setCantMesaEntradaAssigned] = useState(0);

  let location = useLocation();
  const { headerTitle, headerSubTitle } = getHeaders(
    menu,
    navMenuData,
    location.pathname.substring(1)
  );

  const [cantTicketsUnassigned, setCantTicketsUnassigned] = useState(0);
  const [cantTicketsAssigned, setCantTicketsAssigned] = useState(0);

  useEffect(() => {
    // rol y subrol del usuario
    const userRole = account?.roles?.[0]?.name;
    const userSubRole = account?.sub_role;

    // Filtro el menú lateral
    const filteredMenu = filterMenuByRoles(MenuDataNav, userRole, userSubRole);
    setNavMenuData(filteredMenu);

    // Filtro el menú superior
    const filteredMenuTop = filterMenuByRoles(MenuData, userRole, userSubRole);
    setMenu(filteredMenuTop);

    api(CANT_CLAIM_HV_IVE).then(({ ok, body }) => {
      if (ok) {
        setCantClaim(body.data.total_claims_hv || 0);
        if (body.data.total_claims_hv_assigned !== undefined) {
          setCantClaimAssigned(body.data.total_claims_hv_assigned);
        }
      }
    });

    api(CANT_MESA_DE_ENTRADA).then(({ ok, body }) => {
      if (ok) {
        setCantMesaEntrada(body.data.total_mesa_entrada || 0);
        if (body.data.total_mesa_entrada_assigned !== undefined) {
          setCantMesaEntradaAssigned(body.data.total_mesa_entrada_assigned);
        }
      }
    });

    api(CANT_TICKETS).then(({ ok, body }) => {
      if (ok) {
        setCantTicketsUnassigned(body.data.total_tickets_unassigned || 0);
        if (body.data.total_tickets_assigned !== undefined) {
          setCantTicketsAssigned(body.data.total_tickets_assigned);
        }
      }
    });

  }, []);
  /* useEffect(() => {
    const filteredMenu = MenuDataNav.filter((item) =>
      item.rolesAllowed.includes(account["roles"][0].name)
    );
    setNavMenuData(filteredMenu);
    const filteredMenuTop = MenuData.filter((item) =>
      item.rolesAllowed.includes(account["roles"][0].name)
    );
    setMenu(filteredMenuTop);

    api(CANT_CLAIM_HV_IVE).then(({ ok, body }) => {
      if (ok) {
        setCantClaim(body.data.total_claims_hv || 0);
        if (body.data.total_claims_hv_assigned !== undefined) {
          //console.log('INFO: ', account);
          setCantClaimAssigned(body.data.total_claims_hv_assigned);
        }
      }
    });
    api(CANT_MESA_DE_ENTRADA).then(({ ok, body }) => {
      if (ok) {
        setCantMesaEntrada(body.data.total_mesa_entrada || 0);
        if (body.data.total_mesa_entrada_assigned !== undefined) {
          setCantMesaEntradaAssigned(body.data.total_mesa_entrada_assigned);
        }
      }
    });
  }, []); */

  useEffect(() => {
    const currentPath = location.pathname.split("/")[1];
    setCurrentPath(currentPath);
  }, [location]);

  // Validamos el sub_role
  const adminSubRoles = ["apGeneral", "apAdministrativo", "apProfesional"];
  const isAdminProfile = adminSubRoles.includes(account?.sub_role);

  return (
    <>
      <Grid
        container
        spacing={1}
        className={`swt-navbar ${isNavbarCollapsed ? "collapsed" : ""}`}
      >
        <Grid item size={{ xs: 12, sm: 3, md: 3 }}>
          <Menu iconShape="square" className="swt-navbar-content">
            {navMenuData.map((elem, index) => {
              const isActive = location.pathname.startsWith(`/${elem.path}`);
              return (
                <ItemNav
                  key={index}
                  index={index}
                  title={elem.title}
                  to={`/${elem.path}`}
                  isActive={isActive}
                  subItems={elem.subItems}
                  isOpen={openSubMenu === index}
                  setOpenSubMenu={setOpenSubMenu}
                />
              );
            })}
          </Menu>
        </Grid>
        <Grid
          item
          size={{ xs: 12, sm: 9, md: 9 }}
          sx={{ display: "flex", flexDirection: "column" }}
        >
          <Grid item size={{ xs: 12, sm: 12, md: 12 }}>
            <Menu iconShape="square">
              <Box
                sx={{
                  display: "flex",
                  flexDirection: { xs: "column", md: "row" },
                  justifyContent: "space-between",
                  gap: "20px",
                }}
              >
                {menu.map((elem, index) => {
                  const isActive = elem.path.split("/")[0] === currentPath;
                  if (!elem.show) return null;
                  return (
                    <Item
                      key={index}
                      title={elem.title}
                      to={`/${elem.path}`}
                      isActive={isActive}
                      subItems={elem.subItems}
                      cantClaim={cantClaim}
                      cantMesaEntrada={cantMesaEntrada}
                    />
                  );
                })}
              </Box>
            </Menu>
          </Grid>
        </Grid>
        <Grid
          item
          size={{ xs: 12 }}
          sx={{
            borderRadius: "20px",
            backgroundColor: "#fff",
            p: "30px 60px 30px 60px",
            flexGrow: 1,
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              fontFamily: "Encode Sans",
              fontWeight: "600",
              fontSize: "22px",
            }}
          >
            {headerTitle}
          </Typography>
          <Typography
            sx={{
              fontFamily: "Encode Sans",
              fontWeight: "300",
              fontSize: "16px",
            }}
          >
            {headerSubTitle}
          </Typography>
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: "6px",
              mt: "15px",
              pt: "10px",
              borderTop: "1px solid #eaeaea"
            }}
          >
            <Typography sx={{ fontSize: "14px", color: "#00AEC3", fontFamily: "Encode Sans" }}>
              <strong>{account.full_name}</strong>:
            </Typography>

            <Box sx={{ display: "flex", gap: "25px", pl: "0px" }}>
              <Typography sx={{ fontSize: "13px", color: "#555", fontFamily: "Encode Sans" }}>
                {account?.roles?.some(r => r.name === "Admin") ? (
                  <>
                    • Tenés <strong>{cantMesaEntradaAssigned}</strong> reclamos nuevos en Mesa de entrada y <strong>{cantClaimAssigned}</strong> Reclamos IVE
                  </>
                ) : (
                  <>
                    • Tenés <strong>{cantMesaEntradaAssigned}</strong> reclamos nuevos en Mesa de entrada
                  </>
                )}
              </Typography>
            </Box>

            <Box sx={{ display: "flex", gap: "25px", pl: "0px" }}>
              {isAdminProfile && (
                <Typography sx={{ fontSize: "13px", color: "#555", fontFamily: "Encode Sans" }}>
                  • Tenés <strong>{cantTicketsAssigned}</strong> tickets asignados (y hay <strong>{cantTicketsUnassigned}</strong> sin asignar en el buzón).
                </Typography>
              )}
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}

export default Navbar;
